import { render } from "./TagRegisterPost.vue?vue&type=template&id=29a17f2a&scoped=true"
import script from "./TagRegisterPost.vue?vue&type=script&lang=js"
export * from "./TagRegisterPost.vue?vue&type=script&lang=js"

import "./TagRegisterPost.vue?vue&type=style&index=0&id=29a17f2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29a17f2a"]])

export default __exports__